
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                  關於錏設工程行
                  <br />
                  <strong>品質第一、客戶滿意</strong>
                </h1>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  錏設工程行成立於2016年，由黃美玲先生領軍，累積30年豐富的實務經驗。
                  我們專注於各類工業及公共工程的<strong>噴砂噴漆服務</strong>，曾參與多項大型工程專案，
                  憑藉嚴謹的技術與品質控管，贏得眾多合作夥伴的信賴。
                </p>
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  公司堅持「品質第一、客戶滿意」的宗旨，詳細規劃每一次施工流程，
                  確保<strong>工程承攬</strong>品質達到最高標準。我們的專業團隊配備最新噴砂與噴漆設備，
                  嚴格遵守安全規範，致力於打造安全、耐用、美觀的工程作品。
                </p>

                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="text-center p-4 bg-gray-50 rounded-lg">
                    <div className="text-2xl font-bold text-teal-600 mb-2">2016</div>
                    <div className="text-gray-600">成立年份</div>
                  </div>
                  <div className="text-center p-4 bg-gray-50 rounded-lg">
                    <div className="text-2xl font-bold text-teal-600 mb-2">30+</div>
                    <div className="text-gray-600">年實務經驗</div>
                  </div>
                </div>
              </div>

              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/31ca9f5f2ec9e3dacd797af5313c8e08.jpeg"
                  alt="錏設工程行專業團隊"
                  className="w-full h-96 object-cover object-top rounded-xl shadow-lg"
                />
              </div>
            </div>

            <div className="mt-20">
              <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">我們的優勢</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="text-center p-6 bg-gray-50 rounded-xl">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-user-star-line text-teal-600 text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">專業團隊</h3>
                  <p className="text-gray-600">
                    由黃美玲先生領軍的專業團隊，擁有豐富的實務經驗與專業技術
                  </p>
                </div>
                <div className="text-center p-6 bg-gray-50 rounded-xl">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-settings-3-line text-teal-600 text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">先進設備</h3>
                  <p className="text-gray-600">
                    配備最新噴砂與噴漆設備，確保施工品質與效率
                  </p>
                </div>
                <div className="text-center p-6 bg-gray-50 rounded-xl">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-shield-check-line text-teal-600 text-2xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">安全規範</h3>
                  <p className="text-gray-600">
                    嚴格遵守安全規範，確保施工過程安全無虞
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-20">
              <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">公司理念</h2>
              <div className="bg-teal-50 rounded-xl p-8">
                <div className="text-center">
                  <h3 className="text-xl font-semibold text-teal-800 mb-4">品質第一、客戶滿意</h3>
                  <p className="text-lg text-gray-700 leading-relaxed max-w-4xl mx-auto">
                    我們始終堅持以客戶需求為導向，提供最優質的服務。每一個專案都經過嚴格的品質控管，
                    從前期規劃到施工完成，我們都以最高標準要求自己，確保每位客戶都能獲得滿意的成果。
                    這不僅是我們的承諾，更是我們30年來始終不變的經營理念。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
